module.exports = __webpack_public_path__ + "static/media/thiago_portegues_brazillain.b398a4f8.mp3";